export default "__VITE_ASSET__mp7ryhIV__"